"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkFolders = void 0;
const rxjs_1 = require("rxjs");
const redux_observable_1 = require("redux-observable");
const operators_1 = require("rxjs/operators");
const Actions = require("../../../actions/vektorio/linkFolders");
const ActionTypes = require("../../../actionTypes/vektorio/linkFolders");
const ActionsLinkedFolder = require("../../../actions/vektorio/linkedFolders");
const errorHandling_1 = require("../../../utils/errorHandling");
function linkFolders(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, redux_observable_1.ofType)(ActionTypes.LINK_REQUEST), (0, operators_1.switchMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/bim/projects/${action.payload.project.uuid}/vektorio/${action.payload.vektorio.vektorioId}/folders`,
        body: {
            mode: action.payload.mode,
            folderIds: action.payload.folders.map(({ id }) => id)
        }
    }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.linkSuccess(), ActionsLinkedFolder.fetchLinkedRequest({
        project: action.payload.project,
        vektorio: action.payload.vektorio
    }))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.linkFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.linkFolders = linkFolders;
//# sourceMappingURL=index.js.map